import { prefixArray } from "./AIAHD201906/MedicalQuestionnaire";

const requiredText = "Required";
const yesValue = "Yes";

const validateRequired = value => !value && requiredText;

const validateRequiredForHabits = (values, errors, member) => {
  if (values[`${member}ConsumeAlcohol`] === yesValue && !values[`${member}AlcoholDetails`]) {
    errors[`${member}AlcoholDetails`] = requiredText;
  }

  if (values[`${member}Smoke`] === yesValue && !values[`${member}SmokeQuantity`]) {
    errors[`${member}SmokeQuantity`] = requiredText;
  }

  if (values[`${member}SmokeLess`] === yesValue && !values[`${member}SmokeLessQuantity`]) {
    errors[`${member}SmokeLessQuantity`] = requiredText;
  }

  if (values[`${member}WeightLoss`] === yesValue && !values[`${member}WeightLossReason`]) {
    errors[`${member}WeightLossReason`] = requiredText;
  }

  if (
    values[`${member}PreHealthScreening`] === yesValue &&
    !values[`${member}PreHealthScreeningDetails`]
  ) {
    errors[`${member}PreHealthScreeningDetails`] = requiredText;
  }

  if (values[`${member}PapSmear`] === yesValue && !values[`${member}PapSmearResult`]) {
    errors[`${member}PapSmearResult`] = requiredText;
  }

  if (values[`${member}BreastCancer`] === yesValue) {
    if (!values[`${member}BreastCancerFamilyRelation1`]) {
      errors[`${member}BreastCancerFamilyRelation1`] = requiredText;
    }

    // eslint-disable-next-line no-secrets/no-secrets
    if (!values[`${member}BreastCancerFamilyAgeDiagnosed1`]) {
      // eslint-disable-next-line no-secrets/no-secrets
      errors[`${member}BreastCancerFamilyAgeDiagnosed1`] = requiredText;
    }
  }

  if (values[`${member}Pregnant`] === yesValue && !values[`${member}PregnantDurationValue`]) {
    errors[`${member}PregnantDurationValue`] = requiredText;
  }

  if (values[`${member}HaveBeenPregnant`] === yesValue && !values[`${member}HaveBeenPregnantAge`]) {
    errors[`${member}HaveBeenPregnantAge`] = requiredText;
  }
};

const validateRequiredForQuestionnaire = (values, errors) => {
  const requiredMapping = {
    Ques4: ["Ques4a", "Ques4b", "Ques4c"],
    Ques5: ["Ques5a"],
    Ques10a: ["Ques10a-1"],
    Ques11a: ["Ques11a-1"],
    Ques11b: ["Ques11b-1"],
  };
  for (const prefix of prefixArray) {
    // eslint-disable-next-line guard-for-in
    for (const field in requiredMapping) {
      const toCheckFieldArray = requiredMapping[field];
      for (const toCheckField of toCheckFieldArray) {
        if (
          values[`${prefix}${field}`] === yesValue &&
          values[`${prefix}${toCheckField}`].trim() === ""
        ) {
          errors[`${prefix}${toCheckField}`] = requiredText;
        }
      }
    }
  }
};

const validateForm = (values, { form, data }) => {
  const errors = {};

  Object.values(data).forEach(field => {
    if (field.isRequired && !values[field.fieldName] && !field.isReadOnly) {
      errors[field.fieldName] = requiredText;
    }
  });

  if (form === "AIAHD201706_NOCHILD") {
    validateRequiredForHabits(values, errors, "Emp");
    validateRequiredForHabits(values, errors, "Sp");
    validateRequiredForHabits(values, errors, "Ch");
  } else if (form === "AIAHD201906") {
    validateRequiredForQuestionnaire(values, errors);
  }

  return errors;
};

export { validateForm, validateRequired };



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/validation.js